import dayjs from 'dayjs';

export function wasYesterday(date: Date): boolean {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  return dayjs(yesterday).isSame(date, 'day');
}
